<template>
    <div class="relative">
        <AxiosOverlayer :loading="axiosCall"/>
        <div class="bg-white">
            <section class="container mx-auto px-2 pt-4 relative z-20">
                <div class="flex items-center mb-10"><h1 class="flex-grow mb-0 flex items-center">Ergebnisse <span class="text-gray-300 text-sm lining-nums tabular-nums">(v{{ resultData.version }})</span></h1>
                    <base-button :router-link="true" :link="'/form/edit/' + resultData.id + '/' + (resultData.version)" button-class="invert">zurück
                    </base-button>
                    <base-button type="button" class="button-min-width ml-2" @click="getPdf">
                        PDF erstellen
                    </base-button>
                </div>
                <div class="border border-gray-200 mb-8" v-if="resultData.generalData">
                    <div class="flex flex-nowrap -mx-4">
                        <div class="w-full px-4 pl-10 py-6 text-left flex items-center font-bold text-xl">
                            Ihre Angaben:
                        </div>
                        <div class="w-full px-4 py-6 text-left flex flex-col items-center">
                            <div class="w-full text-left font-bold">Projekt</div>
                            <div class="w-full text-left text-sm">{{
                                    resultData.generalData.name
                                }}{{
                                    resultData.generalData.projectNumber ? ' (' + resultData.generalData.projectNumber + ')' : ''
                                }}
                            </div>
                        </div>
                        <div class="w-full px-4 py-6 text-left flex flex-col items-center">
                            <div class="w-full text-left font-bold">Gebäudestatus</div>
                            <div class="w-full text-left text-sm">{{ $t('calculator.' + resultData.houseState) }}</div>
                        </div>
                        <div class="w-full px-4 py-6 text-left flex flex-col items-center">
                            <div class="w-full text-left font-bold">Haustyp</div>
                            <div class="w-full text-left text-sm">{{
                                    $t('calculator.' + resultData.houseVariant)
                                }}
                            </div>
                        </div>
                        <div class="w-full px-4 py-6 text-left flex flex-col items-center">
                            <div class="w-full text-left font-bold">Sanierungsvariante</div>
                            <div class="w-full text-left text-sm">{{
                                    $t('calculator.change_' + resultData.houseAction)
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex -mx-4 justify-between flex-nowrap items-stretch">
                    <template v-for="(tab, tabIndex) in tabs">
                        <div class="px-4 w-full">
                            <div class="w-full h-full border text-center px-2 py-6 border-b-0 transition ease-in-out duration-300" @click="setActiveTab(tabIndex)" :class="[tabIndex == activeTabIndex ? 'border-gray-100 bg-body-color pointer-events-none' : 'border-gray-200 cursor-pointer']">
                                <Icon :name="tab.icon" class="mx-auto inline-block text-primary-default" height="8" width="8"/>
                                <div class="font-bold text-base" v-html="tab.name"></div>
                            </div>
                        </div>
                    </template>
                </div>
            </section>
        </div>
        <div class="bg-body-color pt-8">
            <section class="container mx-auto px-2 py-4 relative z-20">
                <div v-if="showTabContent('result_table')" class="tab-content">
                    <template v-if="resultData && Object.keys(resultData).length > 0">
                        <ResultTable :result-data="resultData" :key="'table-'+resultData.variants.length + '-' +Date.now()" class="fade-in"/>
                    </template>
                    <!--<ResultTable v-if="resultData && Object.keys(resultData).length === 0 && resultData.constructor === Object" :result-data="resultData"/>-->
                </div>
                <div v-if="showTabContent('result_chart_costs')" class="tab-content">
                    <template v-if="resultData && Object.keys(resultData).length > 0">
                        <ResultChartCost :chart-costs="resultData.chart_costs" :key="'chart-costs-'+resultData.variants.length + '-' +Date.now()" class="fade-in"/>
                    </template>
                </div>
                <div v-if="showTabContent('result_chart_co2')" class="tab-content">
                    <template v-if="resultData && Object.keys(resultData).length > 0">
                        <ResultChartCo2 :chart-co2="resultData.chart_co2" :key="'chart-co2-'+resultData.variants.length + '-' +Date.now()" class="fade-in"/>
                    </template>
                </div>
                <div v-if="showTabContent('result_description')" class="tab-content">
                    <template v-if="resultData && Object.keys(resultData).length > 0">
                        <ResultDescription :house-state="resultData.houseState" :key="'chart-description-'+resultData.variants.length + '-' +Date.now()" class="fade-in"/>
                    </template>
                </div>
                <div class="flex items-center mb-10 justify-end">
                    <base-button :router-link="true" :link="'/form/edit/' + resultData.id + '/' + (resultData.version)" button-class="invert">zurück
                    </base-button>
                    <base-button type="button" class="button-min-width ml-2" @click="getPdf">
                        PDF erstellen
                    </base-button>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

import {ref, computed, getCurrentInstance, onMounted, onBeforeMount, reactive, nextTick} from 'vue'
import {useStore} from "vuex";
import {API} from "@/utils/api";
import {useRoute, useRouter} from "vue-router";

export default {
    setup() {
        const axiosCall = ref(false);
        const internalInstance = getCurrentInstance();
        const moment = internalInstance.appContext.config.globalProperties.$moment;
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        const tabs = reactive([
            {
                "slug": "result_table",
                "name": "Ergebnisse",
                "icon": "ergebnisse",
                "hash": "ergebnisse"
            },
            {
                "slug": "result_chart_costs",
                "name": "Diagramm",
                "icon": "diagramm",
                "hash": "diagramm"
            },
            {
                "slug": "result_chart_co2",
                "name": "THG-Emissionen",
                "icon": "thg_emissionen",
                "hash": "co2-emissionen"
            },
            {
                "slug": "result_description",
                "name": "Erläuterung",
                "icon": "erlaeuterungen",
                "hash": "erlaeuterungen"
            }
        ]);

        const activeTabIndex = ref(0);

        const setActiveTab = (tabIndex) => {
            router.push('/form/result/' + resultData.value.id + '#' + tabs[tabIndex].hash);
            activeTabIndex.value = tabIndex;
        }

        const router = useRouter();
        const route = useRoute();
        const store = useStore();

        const resultData = computed(() => store.getters['Calculator/getResultData']);

        const showTabContent = (tabSlug) => {
            return activeTabIndex.value == tabs.map(e => e.slug).indexOf(tabSlug);
        }

        const getResult = () => {
            if (route.hash) {
                route.hash
                const index = tabs.findIndex(tab => '#' + tab.hash === route.hash);
                if (index && activeTabIndex.value != index) activeTabIndex.value = index;
            }

            axiosCall.value = true;

            console.log('{id: route.params.id}',{id: route.params.id})

            API.post('getResult', {id: route.params.id}).then((resp) => {
                axiosCall.value = false;

                const resultData = resp.data.result;
                resultData.generalData = resp.data.project.generalData
                console.log('resultData', resultData.version)
                store.dispatch('Calculator/setResultData', resultData);
            }).catch(err => {
                axiosCall.value = false
                console.error(err)
                emitter.emit("flash-message", {
                    text: 'Fehler',
                    type: 'error'
                })
                router.push('/projects');
            })
        }

        onBeforeMount(async () => {

            await nextTick();
            getResult();
        })

        const getPdf = () => {

            axiosCall.value = true;

            const pdfData = {id: route.params.id}

            API.post('getPdf',
                pdfData,
                {
                    'responseType': 'blob',
                    'Accept': 'application/pdf'
                }
            ).then((response) => {
                axiosCall.value = false;
                console.log(response.data);

                const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                const link = document.createElement('a');
                console.log(link);
                link.href = url;
                let now = new Date();


                link.setAttribute('download', 'bdew_' + moment(now).format('YYYY-MM-DD') + '_projekt_' + pdfData.id + '.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();

            }).catch(err => {
                axiosCall.value = false
                console.error(err);

            })
        }

        return {
            axiosCall,
            resultData,
            setActiveTab,
            activeTabIndex,
            tabs,
            showTabContent,
            getPdf
        }
    }
}

</script>

<style scoped>


</style>
